import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOnHandEntryData, IOnHand } from "../models/onHandDelivery";
import { throwApiError } from "./apiError";
import { getTrackingHeadersMap } from "./getTrackingHeaders";

/**
 * CREATE API call using Axios
 * @returns - Create ON Hand and return same object
 */

export const CreateOnHandEntryAPI = async (params: IOnHandEntryData): Promise<IOnHand> => {
  try {
    // Get static headers from map
    const headers = getTrackingHeadersMap(ApiType.ON_HAND_ENTRY_CREATE);
    const response = await axios.post(getUrl(ApiType.ON_HAND_ENTRY_CREATE), params, { headers });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.createOnHandEntry, { badRequestOrder: "errorsFirst" });
  }
};
